export const NOT_FOUND_PATH = '/404';
export const ERROR_PATH = '/500';
